// NETBILLPAUSE1 (DEC-540, DEC-492): the on-screen reason service is paused for non-payment. Everyone signed in at a paused location
// sees one plain sentence above the app, built on the server from the paying account's name (a franchisee names its franchisor; an
// account that pays its own bill is told to pay in Billing, with a link). Asks GET .../billing-notice once a minute while a staff
// session exists; says nothing when service is not paused or the read fails. Text by textContent.

import { getBillingNotice } from "./api.ts";
import { renderBillingNotice } from "./billingNoticeRender.ts";
import { loadSession } from "./session.ts";

const POLL_MS = 60_000;
const NOTICE_ID = "billing-pause-notice";

async function refresh(): Promise<void> {
  const shell = document.getElementById("app-shell");
  const session = loadSession();
  const existing = document.getElementById(NOTICE_ID);
  if (shell === null || session === undefined) {
    existing?.remove();
    return;
  }
  const reply = await getBillingNotice(session.apiBaseUrl, session.tenantId);
  if (reply.status !== 200 || reply.body.paused !== true || typeof reply.body.message !== "string") {
    if (reply.status !== 0) existing?.remove();
    return;
  }
  const node = existing ?? document.createElement("div");
  node.id = NOTICE_ID;
  node.className = "billing-pause-notice";
  node.dataset["testid"] = NOTICE_ID;
  node.setAttribute("role", "alert");
  const text = node.querySelector<HTMLElement>(".billing-pause-text") ?? document.createElement("span");
  text.className = "billing-pause-text";
  text.dataset["testid"] = `${NOTICE_ID}-text`;
  const link = node.querySelector<HTMLAnchorElement>("a") ?? document.createElement("a");
  link.textContent = "Open Billing";
  link.dataset["testid"] = `${NOTICE_ID}-link`;
  if (existing === null) {
    node.append(text, link);
    shell.prepend(node);
  }
  renderBillingNotice(node, text, link, reply.body);
}

let started = false;
/** Starts the minute poll once per page. */
export function startBillingPauseNotice(): void {
  if (started) return;
  started = true;
  void refresh();
  window.setInterval(() => void refresh(), POLL_MS);
  window.addEventListener("focus", () => void refresh());
}
